import { Body5 } from '../typography/Body5';
import { type HTMLAttributes, useMemo } from 'react';
import { classNames } from '@src/utils/classNames';

export type IndicatorProps = {
  count: number;
} & HTMLAttributes<HTMLSpanElement>;

export const Indicator = ({ count, ...spanAttributes }: IndicatorProps) => {
  const countDisplay = useMemo(() => (count > 99 ? '99+' : count), [count]);
  if (count === 0) {
    return <></>;
  }
  return (
    <span
      data-testid="indicator"
      {...spanAttributes}
      className={classNames(
        'p-0.5 px-1 bg-slate-500/16 rounded-full h-5 min-w-5 flex items-center justify-center w-fit',
        spanAttributes.className,
      )}
    >
      <Body5 className="font-normal !text-slate-900">{countDisplay}</Body5>
    </span>
  );
};
